const affiliateCardQuiz = () => import('../views/affiliatecard/quiz/affiliateCardQuiz')

export default [
  {
    path : '/old/affiliate/card-quiz-event',
    name :'affiliate',
    component : affiliateCardQuiz
  },
]